module.exports = __webpack_public_path__ + "static/media/Product-Monatslinsen.29c4269f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Product-Monatslinsen.jpg
// module id = 225
// module chunks = 8